import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import { Entity } from '@inter-ikea-core/core';
import { PlacementResult } from '@inter-ikea-core/core';

const calculateNrOfProductThatFits = (
  product: Product,
  selectedEntityWidth: number | undefined
): number => {
  return selectedEntityWidth
    ? Math.floor(selectedEntityWidth / product.communicatedDimensions.width)
    : 1;
};

const addMultipleOfProduct = (
  coreApi: CoreApi,
  placementResults: PlacementResult[],
  productId: string,
  selectedEntity: Entity,
  nrProductsToAdd: number
) => {
  for (let i = 0; i < nrProductsToAdd; i++) {
    placementResults.push(coreApi.products.addToTarget(productId, selectedEntity));
  }
};

const addSkubbSmallBoxes = (
  coreApi: CoreApi,
  selectedEntity: Entity,
  productId: string,
  product: Product,
  placementResults: PlacementResult[],
  selectedEntityWidth: number | undefined
) => {
  let nrOfProductToAdd = 4;

  if (
    !coreApi.entities.isOneOfProductTypes(selectedEntity, [
      ProductType.PAX_L_DIVIDER,
      ProductType.PAX_T_DIVIDER
    ])
  ) {
    nrOfProductToAdd = calculateNrOfProductThatFits(product, selectedEntityWidth);
  }
  // eslint-disable-next-line no-console
  addMultipleOfProduct(coreApi, placementResults, productId, selectedEntity, nrOfProductToAdd);
};

export const replaceExistingSkubbOrganizerOnShelf = (
  coreApi: CoreApi,
  product: Product | undefined,
  target: Entity,
  selectedEntityWidth: number | undefined,
  coreProductId: string
): PlacementResult[] => {
  const placementResults: PlacementResult[] = [];
  // For skubb cases we only add 1 storage case per entity
  // but for hemmafixare for certain widths we always want to
  // try and add multiple storage cases at once
  if (product?.type === ProductType.PAX_SKUBB_STORAGE_CASES) {
    placementResults.push(coreApi.products.addToTarget(coreProductId, target));
  } else if (
    product?.type === ProductType.PAX_SKUBB_SHOE_BOXES ||
    product?.type === ProductType.PAX_SKUBB_STORAGE_BOXES ||
    product?.type === ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP ||
    product?.type === ProductType.PAX_HEMMAFIXARE_SHOE_BOX
  ) {
    addSkubbSmallBoxes(
      coreApi,
      target,
      coreProductId,
      product,
      placementResults,
      selectedEntityWidth
    );
  }
  return placementResults;
};

export const addSkubbOrganizerOnShelf = (
  coreApi: CoreApi,
  product: Product | undefined,
  target: Entity,
  selectedEntityWidth: number | undefined,
  coreProductId: string
): PlacementResult[] => {
  const placementResults: PlacementResult[] = [];

  if (product?.type === ProductType.PAX_SKUBB_STORAGE_CASES) {
    placementResults.push(coreApi.products.addToTarget(coreProductId, target));
  } else if (
    product?.type === ProductType.PAX_SKUBB_SHOE_BOXES ||
    product?.type === ProductType.PAX_SKUBB_STORAGE_BOXES ||
    product?.type === ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP
  ) {
    addSkubbSmallBoxes(
      coreApi,
      target,
      coreProductId,
      product,
      placementResults,
      selectedEntityWidth
    );
  }
  return placementResults;
};
